import { fetchPOStart, fetchPOSuccess, fetchPOFailure } from "./reducer";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { GET_ALL_PO } from "../../constants/constants";

export const getAllPO =
  (first = 0, offset = 10, status = "", setLoading) =>
  async (dispatch) => {
    try {
      setLoading?.(true);

      dispatch(fetchPOStart());

      const response = await determineBaseUrlAndPerformApiCall(
        GET_ALL_PO(first, offset, status),
        "GET"
      );

      dispatch(fetchPOSuccess(response));

      setLoading?.(false);
    } catch (error) {
      setLoading?.(false);

      dispatch(fetchPOFailure(error.message));
    }
  };